import { askGPT } from '../components/OpenAIService';

// Fonction pour déterminer le thème et le chapitre de manière intelligente
export const analyzeObjectifThemeAndChapter = async (objectif, objectifType) => {
  try {
    const prompt = `
Tu es un assistant qui va catégoriser précisément un objectif selon son thème et son chapitre.

Objectif : "${objectif}"
Type d'objectif : ${objectifType}

Instructions :
1. Détermine le thème principal parmi ces catégories : 
   - Educatif (formation, apprentissage, ...)
   - Professionnel (job, carrière professionnelle...)  
   - Personnel et familial (sport, voyage, loisir...)
   - Business et Finance 

2. Détermine un chapitre pertinent qui décrit le mieux l'objectif : 
    - Développement personnel
    - Formation et apprentissage
    - Évolution de carrière
    - Santé et bien-être
    - Voyages
    - Activités sportives 
    - Développement entrepreneurial
    - Finance et Banque 
    - Activités ludique et créative
    - Gestion immobilière
    - Retraite 

Réponds UNIQUEMENT au format JSON suivant :
{
  "theme": "Thème choisi",
  "chapitre": "Chapitre descriptif de l'objectif"
}

`;

    const response = await askGPT(prompt);
    
    // Parsing de la réponse JSON
    try {
      const result = JSON.parse(response);
      
      // Validation des résultats
      const validThemes = ['Éducatif', 'Professionnel', 'Personnel', 'Business'];
      const theme = validThemes.includes(result.theme) ? result.theme : 'Personnel';
      
      return {
        theme,
        chapitre: result.chapitre || 'Objectifs Personnels'
      };
    } catch (parseError) {
      console.error('Erreur de parsing de la réponse GPT:', parseError);
      
      // Valeurs par défaut en cas d'erreur
      return {
        theme: objectifType === 'project' ? 'Professionnel' : 
               objectifType === 'idea' ? 'Éducatif' : 'Personnel',
        chapitre: 'Objectifs Personnels'
      };
    }
  } catch (error) {
    console.error('Erreur lors de l\'analyse du thème et du chapitre:', error);
    
    // Valeurs par défaut en cas d'erreur
    return {
      theme: objectifType === 'project' ? 'Professionnel' : 
             objectifType === 'idea' ? 'Éducatif' : 'Personnel',
      chapitre: 'Objectifs Personnels'
    };
  }
};